<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <CustomContainer padding="p-8">
      <div class="flex flex-col items-center gap-4 text-center">
        <div v-if="loading" class="loading-container">
          <a-spin size="large" />
        </div>
        <template v-else>
          <div class="cancel-icon mb-4">
            <svg class="w-16 h-16 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              ></path>
            </svg>
          </div>
          <h1 class="text-2xl text_color font-semibold">{{ title }}</h1>
          <p class="text_color opacity-80">{{ message }}</p>
          <a-button class="primary_medium mt-4" @click="goToManageBilling">Return to Billing</a-button>
        </template>
      </div>
    </CustomContainer>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CustomContainer from '@/components/custom/CustomContainer.vue';
import DashboardService from '@/services/DashboardService';
import { message } from 'ant-design-vue';

const router = useRouter();
const props = defineProps({
  sessionId: {
    type: String,
    required: true,
  },
});

const loading = ref(true);
const title = ref('');
const messageRef = ref('');

const goToManageBilling = () => {
  router.push('/manage_billing');
};

const handleCancelledSession = async () => {
  try {
    const response = await DashboardService.handleCancelledCheckout(props.sessionId);
    if (response?.success) {
      title.value = 'Payment Cancelled';
      messageRef.value = 'Your payment was cancelled. No changes have been made to your subscription.';
    } else {
      title.value = 'Session Error';
      messageRef.value = 'Unable to process the cancelled session. Please contact support if this issue persists.';
    }
  } catch (error) {
    console.error('Error handling cancelled checkout:', error);
    title.value = 'Session Error';
    messageRef.value = 'An error occurred while processing your cancelled payment. Please contact support.';
    message.error('Error processing cancelled payment');
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  if (!props.sessionId) {
    title.value = 'Invalid Session';
    messageRef.value = 'No session ID provided.';
    loading.value = false;
    return;
  }
  await handleCancelledSession();
});
</script>

<style scoped>
.loading-container :deep(.ant-spin-dot-item) {
  background-color: white !important;
}

.loading-container :deep(.ant-spin) {
  color: white !important;
}
</style>
